export const lcTopFilterStandard = {
  filtersCollection: {
    items: [
      {
        name: 'all',
        displayName: 'All',
        path: '/learn2/categories/all/',
      },
      {
        name: 'employers',
        displayName: 'For Employers',
        path: '/learn2/categories/employers',
      },
      {
        name: 'employees',
        displayName: 'For Employees',
        path: '/learn2/categories/employees',
      },
    ],
  },
};
